import React from 'react'

import { OrderCell } from './OrderCell';
import { formatAddress, getLocalUTCDate, getLocalUTCTime } from '../../helpers';
import { orderStatuses } from '../../names';

export const Order = ({titles, data, color:c}) => {
    const address = formatAddress(data.address);
    const orderDate = getLocalUTCDate(data.city.UTC, data.date.min);
    const isCancelOrderStatus = data.orderStatus.name === orderStatuses.CANCEL;
    const completionDate = data.completionDate && data.details.finished && !isCancelOrderStatus ? getLocalUTCDate(data.city.UTC, data.completionDate) : '';
    const orderTime = String(getLocalUTCTime(data.city.UTC, data.date, true));

    const clientPhoneAccess = titles.find(title => title.key === 'clientPhone');
    const otherCitiesAccess = titles.find(title => title.key === 'city');
    const otherProfilesAccess = titles.find(title => title.key === 'profileType');

    return (<>
            <OrderCell c={c} value={data.id} />
            <OrderCell c={c} value={data.advertType.name} />
            <OrderCell c={c} value={data.sourceType} expanding={true} />
            <OrderCell c={c} value={data.orderType.name}/>
            <OrderCell c={c} value={data.clientName} expanding={true} />
            <OrderCell c={c} value={data.orderComment} expanding={true} />
            {otherCitiesAccess && <OrderCell c={c} value={data.city.name} />}
            <OrderCell c={c} value={address} expanding={true} />
            <OrderCell c={c} value={orderDate} />
            <OrderCell c={c} value={orderTime} />
            {clientPhoneAccess && <OrderCell c={c} value={data.clientPhone} />}
            {otherProfilesAccess && <OrderCell c={c} value={data.profileType.name} />}
            <OrderCell c={c} value={data.isProfile ? 'Профиль' : 'Непрофиль'} />
            <OrderCell c={c} value={data.orderStatus.name === 'Отмена клиентом' ? 'Отмена' : data.orderStatus.name} />
            <OrderCell c={c} value={data.worker?.fullname} />
            <OrderCell c={c} value={data.totalAmount} />
            <OrderCell c={c} value={data.partsCost} />
            <OrderCell c={c} value={data.clearAmount} />
            <OrderCell c={c} value={data.handOver} />
            <OrderCell c={c} value={completionDate}  />
            <OrderCell c={c} value={data.workerComment} expanding={true} />
        </>
    )
}